import { render, staticRenderFns } from "./EventsMap.vue?vue&type=template&id=ed826330&"
import script from "./EventsMap.vue?vue&type=script&lang=js&"
export * from "./EventsMap.vue?vue&type=script&lang=js&"
import style0 from "./EventsMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports